import React, { useContext, useEffect, useCallback, useRef } from 'react';
import P from 'prop-types';
import InputMask from 'react-input-mask';
import { Button } from '../Button';
import { useForm } from 'react-hook-form';
import { LabelForm } from '../LabelForm';
import { GlobalContext } from '../../contexts/HomeContext';
import { GetUsuario, SaveUser } from '../../utils/utils';

export const Autenticacao = ({ param }) => {
  const { dadosApp, user, setUser } = useContext(GlobalContext);
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm();

  // const isQlubBalcao = dadosApp?.Empresa?.Config?.qlub && dadosApp?.TipoApp === 'BALCAO';

  const validarNomeCompleto = (value) => {
    if (!value || !value.trim()) {
      return 'Informe o seu nome completo';
    }
    const partes = value.trim().split(/\s+/).filter(Boolean);
    if (partes.length < 2) {
      return 'Informe o seu sobrenome';
    }
    return true;
  };

  const handleValidForm = (form) => {
    if (validarNomeCompleto(form.nomeCompleto) !== true) return;
    const nomeLimpo = (form.nomeCompleto || '').trim().replace(/\s+/g, ' ');
    const arrayOfStrings = nomeLimpo.split(' ').filter(Boolean);
    const _nome = arrayOfStrings[0];
    const _sobrenome = arrayOfStrings.slice(1).join(' ');

    const _usuario = { ...user };
    _usuario.idloja = dadosApp.IdLoja;
    _usuario.nome = _nome.trim();
    _usuario.sobrenome = _sobrenome.trim();
    _usuario.nome_completo = nomeLimpo;

    const _telefone = removeMask(form.numeroCelular);
    _usuario.telefone_ddd = _telefone.substring(0, 2);
    _usuario.telefone = _telefone.substring(2);

    SaveUser(dadosApp.IdLoja, _usuario, setUser);
    param.showHideModal();
    param.onClick();
  };

  const removeMask = (el) => {
    let element = el;
    for (let index = 0; index < el.length; index++) {
      element = element.replace('+55', '');
      element = element.replace('_', '');
      element = element.replace('/', '');
      element = element.replace(' ', '');
    }
    return element;
  };

  const handleSetUser = useCallback(
    (_usuario, _idLoja) => {
      SaveUser(_idLoja, _usuario, setUser);
      setValue('nomeCompleto', _usuario.nome_completo, {
        shouldValidate: true,
        shouldDirty: true,
      });
      if (_usuario.telefone_ddd) {
        setValue('numeroCelular', _usuario.telefone_ddd + _usuario.telefone, {
          shouldValidate: true,
          shouldDirty: true,
        });
      }
    },
    [setValue, setUser],
  );

  const initializedRef = useRef(false);

  const handleGetUsuario = useCallback(async () => {
    if (user.id === 0) {
      const usuario = GetUsuario(dadosApp.IdLoja);
      if (usuario) handleSetUser(usuario, dadosApp.IdLoja);
    } else {
      handleSetUser(user);
    }
  }, [user, handleSetUser, dadosApp.IdLoja]);

  useEffect(() => {
    if (!initializedRef.current) {
      initializedRef.current = true;
      handleGetUsuario();
    }
  }, [handleGetUsuario]);

  return (
    <div style={{ margin: '20px 40px 30px', textAlign: 'center' }}>
      <p style={{ paddingBottom: '20px', textAlign: 'center', fontSize: 16 }}>{param.title}</p>

      <form
        onSubmit={handleSubmit(handleValidForm)}
        className="modal-content-dialog padTop20"
        style={{ borderTop: 0, padding: '15px 0px 0 0px' }}
      >
        <div className="form-container">
          <LabelForm text="Nome Completo" />
          <input
            type="text"
            placeholder=""
            disabled={user.ativo}
            className="form-control"
            {...register('nomeCompleto', { validate: validarNomeCompleto })}
          />
          {errors.nomeCompleto && <p className="form-errors">{errors.nomeCompleto.message}</p>}
        </div>

        <div className="form-container">
          <LabelForm text="Celular com ddd" />
          <InputMask
            type="tel"
            placeholder=""
            disabled={user.ativo}
            className="form-control"
            mask={'+5\\5 99 99999 9999'}
            maskChar=" "
            alwaysShowMask={false}
            {...register('numeroCelular', {
              validate: (value) => {
                const _telefone = removeMask(value);
                return _telefone.length === 11;
              },
            })}
          />

          {errors.numeroCelular && <p className="form-errors">Telefone Inválido</p>}
        </div>

        <div className="padTop20 padBottom20">
          {/* <Button type="submit" text="Salvar" textAlign="center" className="btn_1 full-width btnRounded" /> */}
          <Button
            // text={isQlubBalcao ? 'Pagar com Qlub' : ''}
            type="submit"
            icon={'check'}
            // icon={isQlubBalcao ? '' : 'check'}
            className="btnRounded"
          />
        </div>
      </form>

      {/* <div style={{ padding: '20px 0' }}>
        <Button icon="check" className="btnRounded" onClick={() => handleClick(value)} />
      </div> */}
    </div>
  );
};

Autenticacao.propTypes = {
  param: P.object,
};
